import React from 'react';
import { Modal, Input, Form } from 'antd';

class RenombrarProductoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleOkRename = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);

            const form = {
                idProducto: values.idProducto,
                nombre: values.nombre,
                identifier: values.identifier,
                codigo: values.codigo,

            }
            //this.props.onSaveRename
            this.props.onSaveRename(form, this.props.form);
        })
    }

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
        return (
            <Modal
                title="Renombrar producto"
                visible={this.props.visible}
                style={{ top: 30 }}
                width={800}
                onCancel={this.props.onCancel}
                onOk={this.handleOkRename}
            >
                <Form>
                    <div className="row">
                        {getFieldDecorator('identifier', { initialValue: this.props.formValues.identifier })(
                            <input type="hidden" />
                        )}

                        <div className="col-md-12">
                            {getFieldDecorator('idProducto', { initialValue: this.props.formValues.idProducto })(
                                <input type="hidden" />
                            )}

                            <Form.Item>


                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre
                                })(
                                    <Input.TextArea
                                        placeholder="Ingrese nombre de producto"
                                        style={{ height: 300 }}
                                    />
                                )}
                            </Form.Item>

                            <Form.Item label="Código">
                                {getFieldDecorator("codigo", {
                                    initialValue: this.props.formValues.codigo,
                                })(
                                    <Input
                                        placeholder="Código Referencia"
                                        autoComplete="off"
                                        disabled={!this.props.formValues.flagEditCode}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        )

    }
}

export default Form.create()(RenombrarProductoModal)